<h2 class="h2">Having problems?</h2>
<b>Below is a list of instructions that will help resolve any issues you may have.</b>
<br><p>Submitted an assessment and the Assessment List is not showing?  </p>
<ul>
    <li>Navigate to 'New Assessment' then navigate to 'Assessment List' again.</li>
</ul>
<p>Didn't log out but your assessment disappeared? </p>
<ul>
   <li>Navigate to 'Assessment List' then launch the selected assessment. </li>
</ul>